import { type ReactNode } from "react";
import styles from "./TopUpView.module.scss";

interface SavedCardProps {
  icon: ReactNode;
  last4: string;
  isSelected: boolean;
  onClick: (e: React.MouseEvent) => void;
}

export function SavedCard({
  icon,
  last4,
  isSelected,
  onClick,
}: SavedCardProps) {
  return (
    <div
      className={`${styles.savedCard} ${isSelected ? styles.selectedCard : ""}`}
      onClick={onClick}
    >
      {icon}
      <span className={styles.cardLast4}>** {last4}</span>
    </div>
  );
}
